import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Modal } from 'react-bootstrap';

import ga from '../../../analytics';
import { createQuestion, closeModal, isHelpModalOpenSelector, helpModalTypeSelector } from '../redux';
import ChatbotWidget from './ChatbotWidget'; // Make sure the path is correct
import './help-modal.css'
import PlaygroundWidget from './PlaygroundWidget';

const mapStateToProps = state => ({
  isOpen: isHelpModalOpenSelector(state),
  type: helpModalTypeSelector(state),
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    { createQuestion, closeHelpModal: () => closeModal('help') },
    dispatch
  );

const propTypes = {
  closeHelpModal: PropTypes.func.isRequired,
  createQuestion: PropTypes.func.isRequired,
  isOpen: PropTypes.bool.isRequired,
  type: PropTypes.string.isRequired
};

class HelpModal extends PureComponent {
  render() {
    const { isOpen, closeHelpModal, type } = this.props;

    if (isOpen) {
      ga.modalview('/help-modal');
    }

    let ModalContent;
    switch (type) {
      case 'chatbot':
        ModalContent = <ChatbotWidget />;
        break;
      case 'playground':
        ModalContent = <PlaygroundWidget src="https://note.m0.quest/" />;
        break;
      default:
        ModalContent = null;
    }

    if (!ModalContent) {
      return null;
    }

    return (
      <Modal show={isOpen} onHide={closeHelpModal} dialogClassName="help-modal modal-lg">
        <Modal.Header closeButton>
          <Modal.Title className='text-center'>
            {type === 'chatbot' ? 'Ask Quest for Help!' : 'Playground'}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className='text-center'>
          {ModalContent}
        </Modal.Body>
      </Modal>
    );

  }
}

HelpModal.displayName = 'HelpModal';
HelpModal.propTypes = propTypes;

export default connect(mapStateToProps, mapDispatchToProps)(HelpModal);


// WEBPACK FOOTER //
// ./src/templates/Challenges/components/HelpModal.js